import { ChangeEvent, useMemo, useState } from 'react';
import { DropDown } from '../../../component/dropDown';
import { EmptyState, EmptyTxt } from '../../../component/emptyState';
import { Loader } from '../../../component/loader';
import { DeleteModal } from '../../../component/modal/deleteModal';
import {
  useDeleteStoreMutation,
  useGetAllStoresQuery
} from '../../../store/shopping/api';
import { states } from '../../../utils/nigeriaSates';
import { showErrorToast, showSuccessToast } from '../../../utils/toast';
import { generateUrl } from '../../../utils/urlGenerator';
import { StoreListCard } from '../compoonents/storeListCard';
import { AddStore } from '../compoonents/storeModals/addStore';
import searchIcon from '../../../assets/Search.svg';
import {
  AddStoreBtn,
  SearchBar,
  Container,
  Header,
  ListContainer,
  SortContainer,
  Title,
  SearchContainer,
  SearchIcon
} from './styles';
import { Paginate } from '../../../component/pagenate';
import useDebounce from '../../../utils/useDebounce';

export const AllStores = () => {
  const [sortBy, setSortBy] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [storeId, setStoreId] = useState('');
  const [deleteStoreModal, setDeleteStoreModal] = useState(false);
  const [addStoreModal, setAddStoreModal] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const debounceSearchStore = useDebounce(searchValue, 500);

  const storeDetails = useMemo(
    () =>
      generateUrl({
        type: sortBy.toLowerCase().replace(' ', '-'),
        pageSize: 6,
        search: debounceSearchStore,
        pageNo: pageNumber.toString()
      }),
    [sortBy, pageNumber, debounceSearchStore]
  );

  const { data: allStoreList, isLoading: isStoreListLoading } =
    useGetAllStoresQuery(storeDetails);
  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };
  const [deleteStore, { isLoading: isDeleteStoreLoading }] =
    useDeleteStoreMutation();
  const handleAddStore = () => {
    setAddStoreModal(true);
  };
  const handleDeleteStore = (storeItemId: string) => {
    setDeleteStoreModal(true);
    setStoreId(storeItemId);
  };
  const handleStoreDelete = () => {
    deleteStore(storeId)
      .unwrap()
      .then((result) => {
        showSuccessToast(result.message);
        setDeleteStoreModal(false);
      })
      .catch((error) => {
        showErrorToast(error.message);
      });
  };
  return (
    <Container>
      {isStoreListLoading && <Loader />}
      {addStoreModal && <AddStore setShow={setAddStoreModal} />}
      {deleteStoreModal && (
        <DeleteModal
          deleteTitle="Delete Store"
          isLoading={isDeleteStoreLoading}
          deleteText="Are you sure you want to delete this Store, this action can’t be undone?"
          cancelBtnClick={() => setDeleteStoreModal(false)}
          deleteBtnClick={handleStoreDelete}
        />
      )}
      <Header>
        <Title>All Stores</Title>
        <AddStoreBtn onClick={() => handleAddStore()}>Add Store</AddStoreBtn>
      </Header>
      <SortContainer>
        <SearchContainer>
          <SearchIcon src={searchIcon} alt="" />
          <SearchBar
            type={'text'}
            placeholder=" Search for Item"
            onChange={handleSearchChange}
            value={searchValue}
          />
        </SearchContainer>
        <DropDown
          value={sortBy}
          placeholder={'All Stores'}
          onSelect={(item) => {
            setSortBy(item === 'All stores' ? '' : item);
          }}
          options={['All Stores', ...states]}
        />
      </SortContainer>
      {allStoreList?.data.fetchedData.length ? (
        <ListContainer>
          {allStoreList?.data?.fetchedData.map((item, index) => (
            <StoreListCard
              handleDelete={() => handleDeleteStore(item._id)}
              key={item._id}
              storeItem={item}
            />
          ))}
        </ListContainer>
      ) : (
        <EmptyState>
          <EmptyTxt>
            No store yet, click on the button below to add stores
          </EmptyTxt>
          <AddStoreBtn onClick={() => handleAddStore()}>Add Store</AddStoreBtn>
        </EmptyState>
      )}
      {!!allStoreList?.data.fetchedData.length && (
        <Paginate
          pageNo={allStoreList.data.pageNo}
          noOfPages={allStoreList.data.noOfPages}
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
        />
      )}
    </Container>
  );
};
